export const formatDate = (platformCreatedAt: Date) => {
  return new Date(platformCreatedAt)
    .toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
    })
    .replace(',', ' -');
};

export const formatDateMonth = (timestamp: string) => {
  // Parse the input timestamp to create a Date object
  const date = new Date(timestamp);

  // Extract the year from the input date
  const year = date.getFullYear();

  // Set the new date and time, keeping the year dynamic
  // Note: Months in JavaScript are 0-indexed, so November is 10
  date.setFullYear(year, 10, 12); // Set year, month to November, and day to 12
  date.setHours(12, 0, 0, 0); // Set the time to 12:00:00.000

  // Return the updated timestamp in ISO format
  return date.toISOString();
};
